// Copyright Square, Inc.
import { CUSTOMER_DATA_FRAMEWORK } from "../CustomerDataFramework.js";
/**
 * @see TaxesHubViewTapEvent
 */
export var TaxesHubViewTap = function (_a) {
    var tileType = _a.tileType;
    return ({
        name: "TaxesHub View Tap",
        parameters: {
            cdf_entity: "TaxesHub",
            cdf_action: "View",
            tile_type: tileType !== undefined && tileType !== null ? tileType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see TaxesHubViewViewTimelineEvent
 */
export var TaxesHubViewViewTimeline = function (_a) {
    var returnStatus = _a.returnStatus, stage = _a.stage;
    return ({
        name: "TaxesHub View ViewTimeline",
        parameters: {
            cdf_entity: "TaxesHub",
            cdf_action: "View",
            return_status: returnStatus !== undefined && returnStatus !== null ? returnStatus.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            stage: stage !== undefined && stage !== null ? stage.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see TaxesHubViewViewArticleEvent
 */
export var TaxesHubViewViewArticle = function (_a) {
    var articleName = _a.articleName;
    return ({
        name: "TaxesHub View ViewArticle",
        parameters: {
            cdf_entity: "TaxesHub",
            cdf_action: "View",
            article_name: articleName !== undefined && articleName !== null ? articleName.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see TaxesHubViewRedirectEvent
 */
export var TaxesHubViewRedirect = function (_a) {
    var introCarousel = _a.introCarousel, audience = _a.audience;
    return ({
        name: "TaxesHub View Redirect",
        parameters: {
            cdf_entity: "TaxesHub",
            cdf_action: "View",
            intro_carousel: introCarousel !== undefined && introCarousel !== null ? introCarousel.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            audience: audience !== undefined && audience !== null ? audience.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see TaxesHubExitCloseHubEvent
 */
export var TaxesHubExitCloseHub = function (_a) {
    var hasLoadedContent = _a.hasLoadedContent;
    return ({
        name: "TaxesHub Exit CloseHub",
        parameters: {
            cdf_entity: "TaxesHub",
            cdf_action: "Exit",
            has_loaded_content: hasLoadedContent !== undefined && hasLoadedContent !== null ? hasLoadedContent.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see TaxesHubStartOpenEyrEvent
 */
export var TaxesHubStartOpenEyr = function (_a) {
    var headline = _a.headline, ctaLabel = _a.ctaLabel, source = _a.source;
    return ({
        name: "TaxesHub Start OpenEyr",
        parameters: {
            cdf_entity: "TaxesHub",
            cdf_action: "Start",
            headline: headline !== undefined && headline !== null ? headline.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            ctaLabel: ctaLabel !== undefined && ctaLabel !== null ? ctaLabel.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            source: source !== undefined && source !== null ? source.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see TaxesHubStartOpenTaxesEvent
 */
export var TaxesHubStartOpenTaxes = function (_a) {
    var headline = _a.headline, ctaLabel = _a.ctaLabel, source = _a.source;
    return ({
        name: "TaxesHub Start OpenTaxes",
        parameters: {
            cdf_entity: "TaxesHub",
            cdf_action: "Start",
            headline: headline !== undefined && headline !== null ? headline.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            ctaLabel: ctaLabel !== undefined && ctaLabel !== null ? ctaLabel.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            source: source !== undefined && source !== null ? source.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see TaxesHubBrowseInViewEvent
 */
export var TaxesHubBrowseInView = function (_a) {
    var cardContent = _a.cardContent, articleUrl = _a.articleUrl, source = _a.source;
    return ({
        name: "TaxesHub Browse InView",
        parameters: {
            cdf_entity: "TaxesHub",
            cdf_action: "Browse",
            card_content: cardContent !== undefined && cardContent !== null ? cardContent.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            article_url: articleUrl !== undefined && articleUrl !== null ? articleUrl.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            source: source !== undefined && source !== null ? source.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see TaxesHubBrowseScrollCarouselEvent
 */
export var TaxesHubBrowseScrollCarousel = function (_a) {
    var carouselName = _a.carouselName, fromCard = _a.fromCard, toCard = _a.toCard, interaction = _a.interaction;
    return ({
        name: "TaxesHub Browse ScrollCarousel",
        parameters: {
            cdf_entity: "TaxesHub",
            cdf_action: "Browse",
            carousel_name: carouselName !== undefined && carouselName !== null ? carouselName.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            from_card: fromCard !== undefined && fromCard !== null ? fromCard.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            to_card: toCard !== undefined && toCard !== null ? toCard.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            interaction: interaction !== undefined && interaction !== null ? interaction.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see TaxesHubReadOpenArticleEvent
 */
export var TaxesHubReadOpenArticle = function (_a) {
    var articleName = _a.articleName, articleUrl = _a.articleUrl;
    return ({
        name: "TaxesHub Read OpenArticle",
        parameters: {
            cdf_entity: "TaxesHub",
            cdf_action: "Read",
            article_name: articleName !== undefined && articleName !== null ? articleName.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            article_url: articleUrl !== undefined && articleUrl !== null ? articleUrl.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see TaxesHubAccessOpenDocumentsEvent
 */
export var TaxesHubAccessOpenDocuments = function () { return ({
    name: "TaxesHub Access OpenDocuments",
    parameters: {
        cdf_entity: "TaxesHub",
        cdf_action: "Access",
    }
}); };
/**
 * @see TaxesHubAccessOpenSupportEvent
 */
export var TaxesHubAccessOpenSupport = function () { return ({
    name: "TaxesHub Access OpenSupport",
    parameters: {
        cdf_entity: "TaxesHub",
        cdf_action: "Access",
    }
}); };
